import { render, staticRenderFns } from "./LeadlikeTabLink.vue?vue&type=template&id=767db52c&scoped=true&"
import script from "./LeadlikeTabLink.vue?vue&type=script&lang=js&"
export * from "./LeadlikeTabLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767db52c",
  null
  
)

export default component.exports